import React, { Fragment, useRef, useState } from 'react';

import { UploadFieldInput } from './uploadFieldInput/UploadFieldInput';
import { UploadSingleFileFieldProps } from './UploadSingleFileField.types';

export const UploadSingleFileField = ({
  input,
  className,
  meta,
  allowedExtensions,
  label,
}: UploadSingleFileFieldProps) => {
  const ref = useRef<HTMLInputElement>(null);
  const [file, setFile] = useState<any>(null);

  const handleRemoveFile = () => {
    if (ref.current) {
      ref.current.value = '';
      input.onChange('');
      setFile(null);
    }
  };

  const handleSelectFiles = () => {
    if (ref.current) {
      ref.current.click();
    }
  };

  const handleChange = () => {
    if (ref.current && ref.current.files) {
      setFile(ref.current.files[0]);
      input.onChange(ref.current.files[0]);
    }
  };

  return (
    <Fragment>
      <UploadFieldInput
        className={className}
        onRemove={handleRemoveFile}
        onSelectFiles={handleSelectFiles}
        label={label}
        meta={meta}
        value={file}
      >
        <input
          type="file"
          onChange={handleChange}
          ref={ref}
          accept={allowedExtensions.join(', ')}
          className="input_file"
        />
      </UploadFieldInput>
    </Fragment>
  );
};
